import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Tooltip, Table, LoadingIndicator } from '@components';
import { useSelector } from 'react-redux';
import { AlteracaoPercentualContribuicaoService } from '@services/alteracao-contribuicao';

export const HistoricoIntencaoMudancaPercentualContribuicao = () => {
  const matricula = useSelector((state) => state.user.data?.matricula);
  const [loading, setLoading] = useState(false);
  const [historico, setHistorico] = useState([]);

  const getHistoricoIntencaoTroca = useCallback(async () => {
    setLoading(true);
    const alteracaoPercentualService =
      new AlteracaoPercentualContribuicaoService();
    const historicoIntencaoTroca =
      await alteracaoPercentualService.getHistoricoIntencaoMudancaPercentualContribuicao(
        matricula
      );
    setHistorico(historicoIntencaoTroca);
    setLoading(false);
  }, [matricula]);

  useEffect(() => {
    getHistoricoIntencaoTroca();
  }, [getHistoricoIntencaoTroca]);

  return !loading ? (
    <>
      <Helmet>
        <title>
          Histórico de Intenção de Mudança de Percentual de Contribuição
        </title>
      </Helmet>
      <div className="card">
        <div className="card-body">
          <span className="fw-bold ts-10 mb-32 mb-md-5">
            Histórico de Intenção de Mudança de Percentual de Contribuição
            <Tooltip title="Veja o histórico de intenção de mudança de percentual de contribuição">
              ?
            </Tooltip>
          </span>
          <Table
            className=" mb-4 mt-32"
            odd
            columns={[
              'Data Solicitação',
              'Percentual Atual',
              'Percentual Solicitado',
              'Data Hora Registro',
            ]}
          >
            {historico.map((linha) => {
              return (
                <tr key={linha.DataHoraRegistro}>
                  <td>{linha.DataSolicitacao}</td>
                  <td>{linha.PercentualVigente}</td>
                  <td>{linha.PercentualDesejado}</td>
                  <td>{linha.DataHoraRegistro}</td>
                </tr>
              );
            })}
          </Table>
        </div>
      </div>
    </>
  ) : (
    <LoadingIndicator />
  );
};
